export const LOGIN_REQUESTED = "LOGIN_REQUESTED";
export const LOGIN_SUCCEEDED = "LOGIN_SUCCEEDED";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const CLEAR_STATE = "CLEAR_STATE";
export const LOGOUT = "LOGOUT";